import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Page } from "@/components/Layout";
import { api } from "@/lib/api";
import { ArrowRight, Calendar } from "@phosphor-icons/react";
import PageLoader from "@/components/PageLoader";
import { useCurrency } from "@/lib/currency";

export default function TherapistDetail() {
  const { id } = useParams();
  const { format } = useCurrency();
  const [t, setT] = useState(null);
  useEffect(() => { api.get(`/therapists/${id}`).then((r) => setT(r.data)); }, [id]);
  if (!t) return <Page><PageLoader /></Page>;
  return (
    <Page>
      <section className="md-section">
        <div className="md-container max-w-5xl grid md:grid-cols-3 gap-10">
          <div className="md:col-span-1">
            {t.photo_url && <img src={t.photo_url} alt={t.name} className="rounded-lg w-full aspect-square object-cover" />}
            <div className="md-card mt-5">
              <div className="md-label-eyebrow mb-2">{t.title}</div>
              <p className="text-sm">Languages: {t.languages.join(", ")}</p>
              <p className="text-sm mt-1">Experience: {t.experience_years} yrs</p>
              {t.next_available_slot && (
                <p className="text-sm mt-1" data-testid="therapist-next-available">Next available: {t.next_available_slot}</p>
              )}
              <p className="text-2xl font-serif mt-4" data-testid="therapist-session-fee">{format(t.session_fee)} <span className="text-sm opacity-60">/ session</span></p>
              <Link to={`/book/therapist/${t.id}`} className="btn-primary w-full justify-center mt-4" data-testid="therapist-book-btn"><Calendar size={16} /> Book Session</Link>
            </div>
          </div>
          <div className="md:col-span-2">
            <div className="md-label-eyebrow mb-3">{t.title}</div>
            <h1 className="text-4xl md:text-5xl font-serif mb-5">{t.name}</h1>
            <p className="text-lg break-words" style={{ color: "var(--md-text-soft)", overflowWrap: "anywhere" }}>{t.bio}</p>
            <div className="mt-6">
              <div className="md-label-eyebrow mb-3">Specialisations</div>
              <div className="flex flex-wrap gap-2">
                {t.specialisations.map((s) => <span key={s} className="md-tag">{s}</span>)}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
}
